import { Doctor } from '@magnetar/data-access'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export function useDoctorsByClinicId(clinicId: string | undefined) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<{ success: boolean; data: Doctor[] }>(
    token && clinicId ? `/api/clinic/${clinicId}/doctors` : null,
    undefined,
    token ?? '',
  )

  return {
    doctors: data?.data || [],
    isLoading,
    isError: error,
    mutate,
  }
}
